// extracted by mini-css-extract-plugin
export var active = "_cv-2";
export var recordingDot = "_cv-1";
export var recordingIndicator = "_cv-0";